import Pusher from "pusher-js";

export default new Pusher("bf9e7c10baa820a37878", {
  cluster: "us2",
});
